import React from "react";
import { useBreakpoint } from "app/layout/hooks";
import { ItemProps } from "app/frame/Navigation/interfaces";

import "./style.scss";
import { getPositions, getThirdLevel } from "app/frame/ThirdLevelNavigation/functions";

export const ThirdLevelNavigation = ({ items }: { items: ItemProps[] }) => {
    const isDesktop = useBreakpoint();
    const [positions, setPositions] = React.useState<{ [key: string]: number }>({});

    React.useEffect(() => {
        if (!isDesktop) {
            return;
        }
        setPositions(getPositions(getThirdLevel(items)));
    }, [items, isDesktop]);

    if (!isDesktop) {
        return null;
    }

    return (
        <nav className="thirdLevel">
            {getThirdLevel(items).map(item => (
                <FlyOutMenu key={item.url} {...item} position={positions[item.url] || 0} />
            ))}
        </nav>
    );
};

interface FlyOutMenuProps extends ItemProps {
    position: number;
}

const FlyOutMenu = ({ url, title, children, position }: FlyOutMenuProps) => {
    return (
        <div style={{ left: position }}>
            <a href={url}>{title}</a>
            <nav>
                {children &&
                    children.map(item => (
                        <a
                            key={item.url}
                            href={item.url}
                            rel={item.isAd ? "nofollow" : undefined}
                            className={item.isAd ? "isAd" : undefined}
                        >
                            {item.title}
                        </a>
                    ))}
            </nav>
        </div>
    );
};
